import Vue from 'vue'
import Vuex from 'vuex'
import {HTTP} from '../http/http-common';
import router from '../router';
import moment from 'moment';
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        errorMessage: 'שם משתמש או סיסמה שגויים',
        validDistanceFromDestination: 0.5, //in KM
        userName: window.sessionStorage.getItem('userName') ? window.sessionStorage.getItem('userName') : '',
        days: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
        missionsByBucket: { today: [], future: [], closed: [] },
        bucketLoading: { today: false, future: false, closed: false },
        bucketLoaded: { today: false, future: false, closed: false },
        activeMission: null,
        state: null,
        showLoader: true,
        showLoaderCircular: false,
        receivedCode: false,
        showErrorMessage: false,
        overlay: false,
        duration: 0,
    },
    mutations: {
        /* set the loaded list for a single bucket */
        SET_BUCKET_TASKS: (state, { bucket, tasks }) => {
            Vue.set(state.missionsByBucket, bucket, Array.isArray(tasks) ? tasks : []);
            Vue.set(state.bucketLoaded, bucket, true);
            Vue.set(state.bucketLoading, bucket, false);
        },
        SET_BUCKET_LOADING: (state, { bucket, loading }) => {
            Vue.set(state.bucketLoading, bucket, loading);
        },
        /* get task data */
        GET_TASK_DATA: (state, data) => {
            state.showLoader = true;
            state.activeMission = null;
            state.receivedCode = false;
            state.showLoader = false;
            //set response object to map mutation
            state.activeMission = data.activeMission;
            state.duration = data.duration;
        },
        /* save image to mission using index and base64 image*/
        REMOVE_LAST_IMAGE: (state, data) => {
            state.activeMission.missionPhotos.pop()
        },
        /* login to system*/
        DO_LOGIN: (state, data) => {
            state.showErrorMessage = false;
            HTTP.post('api/login', data).then((response) => {
                if (response && response.token) {
                    window.sessionStorage.setItem('token', response.token);
                    window.sessionStorage.setItem('userName', response.name);
                    state.userName = response.name
                    router.push('/')
                } else {
                    state.showErrorMessage = true;
                }
            }).catch((error) => {
                console.log('error ', error);
                // router.push('/404')
            })
        },
        /* get token code and token valid date*/
        GET_TOKEN_CODE: (state, data) => {
            state.overlay = false;
            state.activeMission.missionCoinID = data.missionCoinID;
            state.activeMission.missionCoinValidDate = data.missionCoinValidDate;
            state.receivedCode = data.receivedCode;
        },
        /* start working on mission*/
        SET_MISSION_AS_ACTIVE: (state, data) => {
            HTTP.put(`api/tasks/startMission/${data.id}`, data).then((response) => {
                console.log(response);
                return response;
            }).catch((error) => {
                console.log(error);
                // router.push('/404')
            })
        },
        /* start working on mission*/
        CANCEL_MISSION: (state, data) => {
            HTTP.post(`api/tasks/cancelMission/${data.id}`, data).then((response) => {
                console.log(response);
                router.push('/')
            }).catch((error) => {
                console.log(error);
                // router.push('/404')
            })
        },
        /* show loader*/
        SHOW_LOADER: (state) => {
            state.showLoader = true;
        },
        /* show loader*/
        HIDE_LOADER: (state) => {
            state.showLoader = false;
        },
        /* show loader*/
        SHOW_OVERLAY: (state) => {
            state.overlay = true;
        },
        /* show loader*/
        HIDE_OVERLAY: (state) => {
            state.overlay = false;
        }
    },
    actions: {
        /* fetch tasks for a single dashboard bucket — one HTTP request per call */
        GET_TASKS_BY_BUCKET(context, bucket) {
            context.commit('SET_BUCKET_LOADING', { bucket, loading: true });
            return new Promise((resolve, reject) => {
                HTTP.get('api/tasks', { params: { bucket } }).then((response) => {
                    const tasks = Array.isArray(response) ? response : [];
                    context.commit('SET_BUCKET_TASKS', { bucket, tasks });
                    resolve(tasks);
                }).catch((error) => {
                    console.error(`Error fetching tasks for bucket "${bucket}":`, error);
                    context.commit('SET_BUCKET_LOADING', { bucket, loading: false });
                    reject(error);
                });
            });
        },
        GET_TOKEN_CODE(context, data) {
            let resp_data = {};
            context.commit('SHOW_OVERLAY');
            return new Promise(function (resolve, reject) {
                HTTP.post(`api/tasks/finishMission/${data.id}`, data).then((response) => {
                    if (response && response.maiCoin) {
                        resp_data.missionCoinID = response.maiCoin;
                        resp_data.missionCoinValidDate = response.missionCoinValidDate + ' 23:55';
                        resp_data.receivedCode = true;
                    }
                    context.commit('GET_TOKEN_CODE', resp_data);

                    resolve(true);
                }).catch((error) => {

                    console.log(error);
                    data.overlay = false;
                    reject(false)
                })

            });
        },
        GET_TASK_DATA(context, id) {
            let data = {};
            return new Promise(function (resolve) {
                HTTP.get('api/tasks/' + id).then((response) => {
                    data.activeMission = response[id];
                    data.activeMission.missionId = id;
                    data.activeMission.missionDestinationCoords = data.activeMission.missionDestinationCoords[0];
                    let end = moment(data.activeMission.missionRangeEnd, 'HH:mm');
                    let start = moment(data.activeMission.missionRangeStart, 'HH:mm');
                    data.duration = end.diff(start, 'hours', true);
                    if (!data.activeMission.missionHoursRange) {
                        data.activeMission.missionHoursRange = 2 // hours range between each point
                    }
                    if (!data.activeMission.missionDistanceFromDestination) {
                        data.activeMission.missionDistanceFromDestination = 0.5 // range radius in KM
                    } else {
                        data.activeMission.missionDistanceFromDestination = data.activeMission.missionDistanceFromDestination / 1000;
                    }
                    data.showLoader = false;
                    data.receivedCode = !!data.activeMission.missionCoinID;

                    context.commit('GET_TASK_DATA', data)
                    resolve(true)
                }).catch((error) => {
                    console.log(error);
                    // router.push('/404')
                })

            })
        },
        SAVE_ROUTE: (context, data) => {
            return new Promise(function (resolve, reject) {
                HTTP.post('api/saveRoute', data).then(() => {
                    resolve(true)
                }).catch(() => {
                    reject(false);
                })
            })
        },
        /* save image to mission using index and base64 image*/
        SAVE_IMAGE: (context, data) => {
            context.state.showLoaderCircular = true;
            return new Promise(function (resolve, reject) {
                HTTP.post('api/uploadAttachment', data).then((response) => {
                    context.state.showLoaderCircular = false;
                    if (response) {
                        resolve(true)
                    } else {
                        reject(false)
                    }
                    resolve(true)
                }).catch((error) => {
                    context.state.showLoaderCircular = false;
                    reject(false);
                })
            })
        },
        /* save image to mission using index and base64 image*/
        GET_TIME: (context, data) => {
            return new Promise(function (resolve, reject) {
                axios.get('https://time.mly.co.il/').then((response) => {
                    if (response) {
                        resolve(response.data)
                    } else {
                        reject(false)
                    }
                    resolve(true)
                }).catch((error) => {
                    reject(false);
                })
            })
        },
        /* submit sub task from sub task popup*/
        SUBMIT_SUB_TASK: (context, data) => {
            return new Promise(function (resolve, reject) {
                HTTP.post('api/saveSubTask', data).then((response) => {
                    context.state.showLoaderCircular = false;
                    if (response) {
                        resolve(true)
                    } else {
                        reject(false)
                    }
                    resolve(true)
                }).catch((error) => {
                    context.state.showLoaderCircular = false;
                    reject(false);
                })
            })

        }
    },
    modules: {}
})
